/* Vitality Lab — reveal observer (v3).
   Adds .is-in to .vl-reveal elements the first time they enter.
   Content remains visible after entry and never re-hides on scroll.
   Respects prefers-reduced-motion (single-fire fallback).
*/
(function () {
  if (window.__vlRevealInit) return;
  window.__vlRevealInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced) {
    // Reduced-motion: fire once, no replay.
    var ioReduced = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          ioReduced.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    scanWith(ioReduced);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  function scanWith(observer, root) {
    (root || document).querySelectorAll('.vl-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  function scan(root) { scanWith(io, root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:reorder', function () { scan(document); });
})();
